var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{style:({ fontWeight: _vm.textFontWeight }),attrs:{"color":"cancel white--text","block":"","tile":""},on:{"click":_vm.clickAction}},[_vm._v(_vm._s(_vm.buttonTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }